import { connect } from 'react-redux';
import { toggleBurgerMenuRequested } from '../../../SiteHeader/redux/actions';
import { getIsBurgerMenuOpen } from '../../../SiteHeader/redux/selectors';
var mapStateToProps = function (state) { return ({
    isBurgerMenuOpen: getIsBurgerMenuOpen(state),
}); };
var mapDispatchToProps = {
    toggleBurgerMenu: toggleBurgerMenuRequested,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Burger.container.js.map